// Entity names are in a separate file to avoid circular dependencies
// between metadata.ts and the individual entity metadata files

export enum EntityName {
  annotation = "annotation",
  contact = "contact",
  account = "account",
  gaming_onboardinghubprofile = "gaming_onboardinghubprofile",
  gaming_onboarding = "gaming_onboarding",
  gaming_hubinvitation = "gaming_hubinvitation",
  ggp_country = "ggp_country",
  gaming_gameconcept = "gaming_gameconcept",
  gaming_ecommerce = "gaming_ecommerce",
  gaming_ecommaddress = "gaming_ecommaddress",
  ggp_contractrequest = "ggp_contractrequest",
  gaming_contracttype = "gaming_contracttype",
  user = "systemuser",
  gaming_contractsubtype = "gaming_contractsubtype",
  gaming_pitchprogram = "gaming_pitchprogram",
  ggp_strike = "ggp_strike",
  gaming_streamreg = "gaming_streamreg",
  gaming_contractregion = "gaming_contractregion",
  gaming_mssigner = "gaming_mssigner",
  gaming_contractautoconfig = "gaming_contractautoconfig",
  gaming_autorequesttopic = "gaming_autorequesttopic",
  gaming_autorequest = "gaming_autorequest",
  gaming_program = "gaming_program",
  gaming_initiatives = "gaming_initiatives",
  gaming_partnerinquiry = "gaming_partnerinquiry",
  gaming_ecommercefile = "gaming_ecommercefile",
  ticket_ticket = "ticket_ticket",
  ticket_ticketattachment = "ticket_ticketattachment",
  ticket_ticketcomment = "ticket_ticketcomment",
  ticket_ticketcontact = "ticket_ticketcontact",
  ticket_ticketproduct = "ticket_ticketproduct",
  ticket_ticketproductfeature = "ticket_ticketproductfeature",
  ticket_ticketpartner = "ticket_ticketpartner",
  ticket_ticketteam = "ticket_ticketteam",
  ticket_ticketteammember = "ticket_ticketteammember",
  ticket_ticketteaminvitation = "ticket_ticketteaminvitation",
  ticket_language = "ticket_language",
}

export enum ExternalEntityName {
  team = "team",
}
